<template>
    <div class="vrm-modal vrm-modal--alert mfp-with-anim">
        <div class="vrm-modal__content">
            <div class="vrm-modal__title">
                {{
                    $t('mfa.verify_to_continue', {
                        i18nFallback: 'Please verify your identity to continue',
                    })
                }}
            </div>
            <br />
            <vrm-form @submit="onSubmit">
                <div class="row">
                    <p v-if="loading">
                        {{
                            $t('mfa.authorize_changes_loading', {
                                i18nFallback: 'Checking security settings...',
                            })
                        }}
                    </p>
                    <p v-else-if="error">
                        {{
                            $t('mfa.authorize_changes_error', {
                                i18nFallback: 'Failed to load two-step verification settings',
                            })
                        }}
                    </p>
                </div>
                <template v-if="!loading && !error">
                    <div class="row">
                        <vrm-text-field
                            v-model="token"
                            :title="
                                $t('mfa.authorize_changes_token', {
                                    i18nFallback: 'Two-step verification code',
                                })
                            "
                            type="text"
                            name="one-time-code"
                            autocomplete="one-time-code"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            required
                            :disabled="busy"
                        />
                    </div>
                    <div class="row">
                        <div class="vrm-modal__main-button">
                            <button type="submit" class="sg-btn sg-blue" :disabled="busy">
                                {{
                                    $t('mfa.authorize_changes_verify', {
                                        i18nFallback: 'Verify',
                                    })
                                }}
                            </button>
                        </div>
                    </div>
                </template>
            </vrm-form>
            <modal-close-handle />
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import { ngInject } from '@/vue/decorators/angular-interop';
import VrmForm from '@/vue/components/forms/VrmForm';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import VrmTextField from '@/vue/components/forms/VrmTextField';

@Component({
    components: { ModalCloseHandle, VrmTextField, VrmForm },
})
@AngularLocaleBundle('mfa')
export default class VerifyMFAModal extends Vue {
    @Prop()
    successCallback;

    token = '';

    loading = false;
    busy = false;
    error = false;
    mfaMode = null;

    @ngInject()
    LoginService;

    async created() {
        this.loading = true;
        try {
            /** @type ProtectedAccessStartResult */
            const result = await this.$store.dispatch('MfaService/protectedAccessStart');
            if (result.success) {
                this.error = false;
                this.mfaMode = result.mfaMode;
            } else {
                this.error = true;
            }
        } finally {
            this.loading = false;
        }
    }

    async onSubmit() {
        this.busy = true;
        this.$emit('close');
        // To prevent next modals not show up
        setTimeout(() => {
            this.successCallback(this.token);
        }, 500);
    }
}
</script>
